import { API_URL } from "../config";

export const GRAPHQL_URL = `${API_URL}/graphql`;
